import { render, staticRenderFns } from "./LoginDataHistory.vue?vue&type=template&id=bad653b6&scoped=true&"
import script from "./LoginDataHistory.vue?vue&type=script&lang=js&"
export * from "./LoginDataHistory.vue?vue&type=script&lang=js&"
import style0 from "./LoginDataHistory.vue?vue&type=style&index=0&id=bad653b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad653b6",
  null
  
)

export default component.exports